export const uri = {
  name: process.env.REACT_APP_URI,
  auth: process.env.REACT_APP_AUTH,
  orders: process.env.REACT_APP_ORDERS,
  socket: process.env.REACT_APP_WS,
  api: process.env.REACT_APP_API,
  bucket: process.env.REACT_APP_BUCKET,
  env: process.env.REACT_APP_ENVIRONMENT,
  menu: process.env.REACT_APP_GET_MENU,
};

export default { uri };
